import AccrualRulesCell from './AccrualRulesCell'
import SickDaysRulesMixin from './SickDaysRulesMixin'

class SickDaysAccrualRulesCell extends AccrualRulesCell {
    constructor() {
        super()
        this.mixin = new SickDaysRulesMixin();
    }
}

export default SickDaysAccrualRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/SickDaysAccrualRulesCell.js